import {
  ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_FETCHING,
  ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_FAILED,
  ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ESTIMATE_PERFORMANCE_EMPLOYEES_STATUS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
